import {createAction} from 'redux-actions';
import {
    getQcReportsNotes,
    setQcReportNote,
    deleteQcReportNote,
    editQcReportNote,
} from '@pluto/rest';
import {setNotificationAction} from '@pluto/notification';
import {curry} from 'ramda';
import {
    DeleteQcReportNoteParams,
    DispatchAny,
    NoteType,
    EditQcReportNoteBody,
} from '@pluto/@types';
import {CreateNewQcReportNoteParams} from '../../QCReportsReasonsTypes';

export const CREATE_NEW_QC_REPORT_NOTE = 'CREATE_NEW_QC_REPORT_NOTE';
export const DELETE_QC_REPORT_NOTE = 'DELETE_QC_REPORT_NOTE';
export const QC_REPORTS_NOTES_SET = 'QC_REPORTS_NOTES_SET';
export const QC_REPORTS_NOTES_RESET = 'QC_REPORTS_NOTES_RESET';

export const createNewQcReportNoteAction = curry(async (params: CreateNewQcReportNoteParams, noteType: NoteType, dispatch: DispatchAny) => {
    const result = await setQcReportNote(params, noteType);
    
    if (result.statusText === 'OK') {
        dispatch(qcReportsNotesSetAction(params.id, noteType));
        
        return dispatch(setNotificationAction({
            type: 'success',
            text: 'QC Report Note successfully created',
        }));
    }
    
    return dispatch(setNotificationAction({
        type: 'error',
        text: 'Error in creating new report note',
    }));
});

export const deleteQcReportNoteAction = curry(async (params: DeleteQcReportNoteParams, noteType: NoteType, dispatch: DispatchAny) => {
    const result = await deleteQcReportNote(params);
    
    if (result.statusText === 'OK') {
        dispatch(qcReportsNotesSetAction(params.qcJobId, noteType));
        
        return dispatch(setNotificationAction({
            type: 'success',
            text: 'QC Report Note successfully deleted',
        }));
    }
    
    return dispatch(setNotificationAction({
        type: 'error',
        text: 'Error in deleting current report note',
    }));
});

export const editQcReportsNoteAction = curry(async (params: DeleteQcReportNoteParams, body: EditQcReportNoteBody, noteType: NoteType, dispatch: DispatchAny) => {
    const result = await editQcReportNote(params, body);
    
    if (result.statusText === 'OK') {
        return dispatch(qcReportsNotesSetAction(params.qcJobId, noteType));
    }
    
    return dispatch(setNotificationAction({
        type: 'error',
        text: 'Couldnt update note',
    }));
});

export const qcReportsNotesSetAction = createAction(QC_REPORTS_NOTES_SET, async (id: string, noteType: NoteType) => {
    return await getQcReportsNotes(id, noteType);
});

export const resetQcReportsNotesAction = createAction(QC_REPORTS_NOTES_RESET);
